import { z } from 'zod';
import type { TFunction } from 'i18next';

const createPhoneFormSchema = (t: TFunction) => {
  const required = t('authPages.validation.requiredField');
  const phoneInvalid = t('authPages.validation.phoneInvalid');

  return z.object({
    countryCode: z.string().nonempty({ message: required }),
    phoneNumber: z
      .string()
      .nonempty({ message: required })
      .regex(/^[0-9]+$/, { message: phoneInvalid }),
  });
};

export { createPhoneFormSchema };
